
export interface CateringMenuItem {
  id: string;
  name: string;
  description: string | null;
  image_url: string | null;
  tags: string[];
  allergens: string[];
  display_order: number;
  price_per_pax: number | null;
  is_default: boolean;
}

export interface CateringMenuCategory {
  id: string;
  name: string;
  display_order: number;
  selection_type: 'all_included' | 'choice';
  min_selection: number | null;
  max_selection: number | null;
  is_required: boolean;
  group_id: string | null;
  items: CateringMenuItem[];
}

export interface CateringCategoryGroup {
  id: string;
  menu_id: string;
  name: string;
  description: string | null;
  sort_order: number;
  min_selection: number | null;
  max_selection: number | null;
}

export interface CateringUpgrade {
  id: string;
  name: string;
  description: string | null;
  image_url: string | null;
  price_per_pax: number | null;
  flat_price: number | null;
  category: string;
  display_order: number;
}

export interface CateringMenu {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  menu_type: 'buffet' | 'bento' | 'package';
  price_per_pax: number | null;
  flat_price: number | null;
  min_pax: number;
  max_pax: number | null;
  tags: string[];
  display_order: number;
  is_active: boolean;
  categories?: CateringMenuCategory[];
  upgrades?: CateringUpgrade[];
  category_groups?: CateringCategoryGroup[];
}

export interface CateringAddon {
  id: string;
  name: string;
  description: string | null;
  image_url: string | null;
  price_per_pax: number | null;
  flat_price: number | null;
  min_quantity: number | null;
  max_quantity: number | null;
  display_order: number;
}

export interface CateringSettings {
  id: string;
  companyCateringVenueSurchargeInhouse: number;
  companyCateringVenueSurchargePrivate: number;
  companyCateringVenueSurchargeExternal: number;
  companyCateringDeliveryFeeBase: number;
  companyCateringPayNowDiscountPercent: number;
  companyCateringMinAdvanceDays: number;
  companyCateringBlockedDates: string[];
  companyCateringTimeSlots:string[];
  companyCateringOrderNotificationEmail:string;
}

/**
 * Organizes flat categories into grouped and ungrouped structure.
 * Groups are sorted by sort_order, categories within groups by display_order.
 */
export interface GroupedCategories {
  groups: Array<{
    group: CateringCategoryGroup;
    categories: CateringMenuCategory[];
  }>;
  ungrouped: CateringMenuCategory[];
}

export function organizeByGroups(
  categories: CateringMenuCategory[],
  groups: CateringCategoryGroup[]
): GroupedCategories {
  const sortedGroups = [...groups].sort((a, b) => a.sort_order - b.sort_order);
  
  const grouped = sortedGroups.map(group => ({
    group,
    categories: categories
      .filter(c => c.group_id === group.id)
      .sort((a, b) => (a.display_order || 0) - (b.display_order || 0)),
  })).filter(g => g.categories.length > 0);

  const ungrouped = categories
    .filter(c => !c.group_id)
    .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));

  return { groups: grouped, ungrouped };
}

export function useCateringMenus(includeCategories: boolean = false) {
 return '';
}
